import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledAddon = styled.div`
  padding: 20px;
  margin-bottom: 40px;
  border-radius: 10px;
  background-color: ${th('colors.yellow')}1F;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;

  @media ${sizes.tabletPortrait} {
    margin-bottom: 22px;
  }
`;

export const AddonIcon = styled.div`
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  background-color: ${th('colors.turquoise')};
  padding: 6px;
  border-radius: 6px;

  > img {
    width: 100%;
  }
`;

export const AddonTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${th('colors.turquoise')};
`;

export const AddonName = styled.div`
  font-size: 18px;
  font-weight: bold;
`;

export const AddonContent = styled.div`
  > * {
    margin: 0;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;
